import { useState } from "react";
import { Search } from "lucide-react";
import "../styles/aiToolsHeader.css";

const ALL_CATEGORIES = ["All", "LLM", "Video", "Image Generation", "Audio", "Developer Tools", "No-Code", "Design", "Content Creation", "Productivity", "Marketing", "Finance", "Legal", "Education", "Entertainment", "Human Resources", "E-mail", "Logo creation", "Websites & Design", "Life Assistants", "Memory", "Healthcare", "Writing & Web SEO"];

export default function AIToolsHeader({ onSearch, onCategory, onPricing, onSort, totalResults }) {
  const [query, setQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [activePricing, setActivePricing] = useState("All");

  const handleSearch = (val) => {
    setQuery(val);
    onSearch?.(val);
  };

  const handleCategory = (cat) => {
    setActiveCategory(cat);
    onCategory?.(cat);
  };

  const handlePricingToggle = (option) => {
    const newVal = activePricing === option ? "All" : option;
    setActivePricing(newVal);
    onPricing?.(newVal);
  };

  return (
    <>
      {/* HERO */}
      <section className="ai-header">
        <div className="ai-header-badge">Updated Daily · 2026 Edition</div>

        <h1>
          Discover the Best <span>AI Tools</span><br />All in One Place
        </h1>

        <p>
          The ultimate AI tools directory — browse, filter, and find the perfect tool
          for writing, coding, image generation, video, and more.
        </p>

        <div className="ai-header-stats">
          <div className="stat-item">
            <div className="stat-number">{totalResults ? `${totalResults}+` : "658+"}</div>
            <div className="stat-label">AI Tools</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">20,000+</div>
            <div className="stat-label">Monthly Users</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10,000+</div>
            <div className="stat-label">Reviews</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">Daily</div>
            <div className="stat-label">Updates</div>
          </div>
        </div>
      </section>

      {/* FILTER BAR */}
      <div className="filter-controls-wrapper">
        {/* ROW 1: STICKY SEARCH */}
        <div className="filter-row search-row-sticky">
          <div className="search-container-sticky">
            <div className="search-wrapper-sticky">
              <Search className="search-icon-sticky" size={18} />
              <input
                id="ai-search-input-sticky"
                type="text"
                placeholder="Search AI tools, categories, use cases..."
                value={query}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <button onClick={() => onSearch?.(query)}>Search</button>
            </div>
          </div>
        </div>

        {/* ROW 2: REDESIGNED FILTERS */}
        <div className="filter-row new-filters-layout-row">
          
          {/* Category Dropdown */}
          <div className="new-filter-item category-dropdown-box">
            <select
              value={activeCategory}
              onChange={(e) => handleCategory(e.target.value)}
              className="new-category-select"
            >
              <option value="All">-- Select a category --</option>
              {ALL_CATEGORIES.filter(c => c !== "All").map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          {/* Pricing Badges */}
          <div className="new-filter-item pricing-badges-box">
            <button
              onClick={() => handlePricingToggle("Free")}
              className={`price-badge free-badge ${activePricing === "Free" ? "active" : ""}`}
            >
              Free AI
            </button>
            <button
              onClick={() => handlePricingToggle("Freemium")}
              className={`price-badge freemium-badge ${activePricing === "Freemium" ? "active" : ""}`}
            >
              Freemium
            </button>
            <button
              onClick={() => handlePricingToggle("Paid")}
              className={`price-badge paid-badge ${activePricing === "Paid" ? "active" : ""}`}
            >
              Paid
            </button>
            <button
              onClick={() => handlePricingToggle("Free Trial")}
              className={`price-badge freetrial-badge ${activePricing === "Free Trial" ? "active" : ""}`}
            >
              Free Trial
            </button>
          </div>

        </div>
      </div>
    </>
  );
}